module.exports = __webpack_public_path__ + "static/media/clinical-donate-cta.08d99cbf.png";